import { Autocomplete, Box, Paper, TextField } from "@mui/material";
import Grid from "@mui/material/Grid2";
import Subheading from "../../../components/common/Subheading";
import { getQuarterOptions } from "../constants/quarters";

/**
 * Form for data-checker task inputs: companies and yyyy-Qx quarter.
 *
 * @param {Object} props
 * @param {string[]} props.companyNames
 * @param {Object} props.formData
 * @param {Function} props.onFormChange
 * @returns {JSX.Element}
 */
function DataCheckerForm({ companyNames, formData, onFormChange }) {
  const quarterOptions = getQuarterOptions();

  const handleCompanyChange = (event, value) => {
    onFormChange({ ...formData, selectedCompanies: value });
  };

  const handleQuarterChange = (event, value) => {
    onFormChange({ ...formData, selectedQuarter: value });
  };

  return (
    <Grid container direction="column" spacing={4} p={3} mx={"10%"}>
      <Paper elevation={2} sx={{ p: 3, borderRadius: 2 }}>
        <Subheading text="Company Selection" sx={{ mb: 3 }} />
        <Autocomplete
          options={companyNames}
          multiple
          renderInput={(params) => <TextField {...params} label="Select Companies" />}
          onChange={handleCompanyChange}
          getOptionLabel={(option) => option}
          value={formData.selectedCompanies}
          fullWidth
          size="medium"
        />
      </Paper>

      <Paper elevation={2} sx={{ p: 3, borderRadius: 2 }}>
        <Subheading text="Quarter Selection" sx={{ mb: 3 }} />
        <Box>
          <Autocomplete
            options={quarterOptions}
            renderInput={(params) => <TextField {...params} label="Select Quarter" />}
            onChange={handleQuarterChange}
            getOptionLabel={(option) => option}
            value={formData.selectedQuarter}
            fullWidth
            size="medium"
          />
        </Box>
      </Paper>
    </Grid>
  );
}

export default DataCheckerForm;
